// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"toolbar_Toolbar__2v16B","Logo":"toolbar_Logo__Re0FU","DesktopOnly":"toolbar_DesktopOnly__27kO_","MobileOnly":"toolbar_MobileOnly__247Hs"};